<onsip-header-main>
  <onsip-header-page-title>{{
    "ONSIP_I18N.EXTERNAL_SIP_ADDRESS" | translate
  }}</onsip-header-page-title>
</onsip-header-main>
<div class="wrapper">
  <router-outlet></router-outlet>
  <div class="mat-body-2 support-wrapper">
    {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </div>
</div>
